import React, { FC } from 'react';

import { MilestoneDateIcon, milestoneDateIconDefaultProps, MilestoneDateIconProps } from './MilestoneDateIcon';
import { ENTITY_COLORIZATION }                                                      from "@src/constants";

const projectMilestoneIconDefaultProps: MilestoneDateIconProps = {
	...milestoneDateIconDefaultProps,
}

const ProjectMilestoneIcon: FC<MilestoneDateIconProps> = ( props ) => {

	return (

		<MilestoneDateIcon { ...props }/>
	);
};

ProjectMilestoneIcon.defaultProps = projectMilestoneIconDefaultProps;

export { ProjectMilestoneIcon }
